import React from 'react';
import Checkout from 'Modules/checkout/routes/Checkout';
import { checkoutPath } from 'Modules/checkout/paths';

export { checkoutPath };

export const routes = [{ path: checkoutPath, element: <Checkout /> }];
